import * as React from 'react';
import { Price } from '@grandvisionhq/common';
import { Text } from '@grandvisionhq/elements';

const PriceLabel = ({ originalPriceInformation , discountedPriceInformation , centAmount  })=>{
    if (!originalPriceInformation) {
        return null;
    }
    const resolvedPriceCentAmount = (discountedPriceInformation === null || discountedPriceInformation === void 0 ? void 0 : discountedPriceInformation.amount) || originalPriceInformation.amount;
    const currencyCode = originalPriceInformation.currencyCode;
    return /*#__PURE__*/ React.createElement(Text, {
        variant: "caption"
    }, /*#__PURE__*/ React.createElement(Price, {
        value: resolvedPriceCentAmount,
        centAmount: centAmount,
        currency: currencyCode
    }));
};

export { PriceLabel };
//# sourceMappingURL=PriceLabel.js.map
